import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { DefaultScrollBar } from '@shared/components/styles/ScrollBar';
import { ColorConstants } from '@shared/constants';

export const useStyles = () => ({
    drawerBody: {
        height: 'calc(100% - 320px)',
    },
    buttonText: {
        fontSize: '14px',
    },
});

export const Title = styled.p`
    font-size: 16px;
    color: ${ColorConstants['regal-blue']};
    line-height: 24px;
    font-weight: 400;
    margin-left: 20px;
    margin-top: 15px;
`;

export const ContainerBody = styled(Grid)`
    margin-top: 12px;
    padding-left: 8px;
`;

export const InputSearchContainer = styled(Grid)`
    margin-bottom: 18px;
    margin-left: 20px;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 90px;
`;

export const ContainerScrollBar = styled.div`
    overflow-y: auto;
    flex:1;
    width: 100%;
    margin-bottom: 16px;
    ${DefaultScrollBar}
    &::-webkit-scrollbar-thumb {
        background-color: ${ColorConstants['regal-blue-50%']};
        border-radius: 20px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 20px;
    }
`;

export const ContainerContent = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    max-height: 90%;
    height:100%;
`;

export const DrawerFieldContainer = styled.div`
    margin: 0 0 8px 20px;
`;
